import { useCallback, useEffect, useState } from "react";

let deferredPrompt = null;
const listeners = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; listeners.forEach((l) => l()); });
  window.addEventListener("appinstalled", () => { deferredPrompt = null; try { localStorage.setItem("apx:installed", "1"); } catch (e) { /* ignore */ } listeners.forEach((l) => l()); });
}

export const detectPlatform = () => {
  const ua = navigator.userAgent || "";
  const iOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (iOS) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
};

export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true || new URLSearchParams(window.location.search).get("src") === "twa";

export const iosBrowser = () => {
  const ua = navigator.userAgent || "";
  if (/CriOS/.test(ua)) return "chrome";
  if (/FxiOS/.test(ua)) return "firefox";
  if (/EdgiOS/.test(ua)) return "edge";
  return "safari";
};

export const useInstallPrompt = () => {
  const [, tick] = useState(0);
  useEffect(() => { const l = () => tick((n) => n + 1); listeners.add(l); return () => listeners.delete(l); }, []);
  const prompt = useCallback(async () => {
    if (!deferredPrompt) return "unavailable";
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") deferredPrompt = null;
    tick((n) => n + 1);
    return outcome;
  }, []);
  return { canPrompt: !!deferredPrompt, prompt, platform: detectPlatform(), standalone: isStandalone(), installed: (() => { try { return localStorage.getItem("apx:installed") === "1"; } catch (e) { return false; } })() };
};
